import React from "react";

interface InfoItem {
    title: string;
    value: string | JSX.Element;
}
interface IProps {
    data: InfoItem[]
}
const InfoHeader: React.FC<IProps> = ({ data }) => {
    return <div className="KCL_infoHeader">
        {
            data.map((item) => (
                <div className="info-col" key={item.title}>
                    <div className="info-item">
                        <span className="title">{item.title}</span>
                        <span className="value">{item.value}</span>
                    </div>
                </div>
            ))
        }
    </div>
}

export default InfoHeader;